<template>
  <div class="content card-group-container">
    <!-- 统计卡片区域 -->
    <el-row :gutter="20" class="stats-row" type="flex">
      <el-col :span="12">
        <div class="stats-card stats-left">
          <div class="legend-total-wrapper">
            <div class="ring-cards">
              <div class="ring-card-item" @click="handleOperatorClick('mobile')">
                <div class="ring-progress ring-mobile">
                  <svg viewBox="0 0 120 120" class="ring-svg">
                    <circle cx="60" cy="60" r="50" fill="none" stroke="#e9ecef" stroke-width="8" />
                    <circle
                      cx="60" cy="60" r="50" fill="none"
                      :stroke="mobileColor"
                      stroke-width="8"
                      stroke-linecap="round"
                      :stroke-dasharray="mobileDashArray"
                      stroke-dashoffset="0"
                      transform="rotate(-90 60 60)"
                    />
                  </svg>
                  <div class="ring-center-icon">
                    <count-to
                      class="center-count count-mobile"
                      :start-val="0"
                      :end-val="statsData.ydCount"
                      :duration="1500"
                    />
                  </div>
                </div>
                <div class="ring-label">移动(张)</div>
              </div>

              <div class="ring-card-item" @click="handleOperatorClick('telecom')">
                <div class="ring-progress ring-telecom">
                  <svg viewBox="0 0 120 120" class="ring-svg">
                    <circle cx="60" cy="60" r="50" fill="none" stroke="#e9ecef" stroke-width="8" />
                    <circle
                      cx="60" cy="60" r="50" fill="none"
                      :stroke="telecomColor"
                      stroke-width="8"
                      stroke-linecap="round"
                      :stroke-dasharray="telecomDashArray"
                      stroke-dashoffset="0"
                      transform="rotate(-90 60 60)"
                    />
                  </svg>
                  <div class="ring-center-icon">
                    <count-to
                      class="center-count count-telecom"
                      :start-val="0"
                      :end-val="statsData.dxCount"
                      :duration="1500"
                    />
                  </div>
                </div>
                <div class="ring-label">电信(张)</div>
              </div>

              <div class="ring-card-item">
                <div class="ring-progress ring-multi">
                  <svg viewBox="0 0 120 120" class="ring-svg">
                    <circle cx="60" cy="60" r="50" fill="none" stroke="#e9ecef" stroke-width="8" />
                    <circle
                      cx="60" cy="60" r="50" fill="none"
                      :stroke="multiColor"
                      stroke-width="8"
                      stroke-linecap="round"
                      :stroke-dasharray="multiDashArray"
                      stroke-dashoffset="0"
                      transform="rotate(-90 60 60)"
                    />
                  </svg>
                  <div class="ring-center-icon">
                    <count-to
                      class="center-count count-multi"
                      :start-val="0"
                      :end-val="statsData.multiCount"
                      :duration="1500"
                    />
                  </div>
                </div>
                <div class="ring-label">多网(张)</div>
              </div>
            </div>
            <div class="tip-text">*点击图标跳转到卡列表查询对应运营商卡片</div>
          </div>
        </div>
      </el-col>

      <el-col :span="12">
        <div class="stats-card stats-right">
          <div class="legend-total-wrapper">
            <div class="legend-list">
              <div class="legend-item">
                <div class="legend-label-group">
                  <span class="legend-dot color-usable"></span>
                  <span class="legend-text">待激活状态</span>
                </div>
                <span class="legend-count"><count-to :start-val="0" :end-val="statsData.usableCard" :duration="100" />张</span>
              </div>
              <div class="legend-item">
                <div class="legend-label-group">
                  <span class="legend-dot color-activated"></span>
                  <span class="legend-text">已激活状态</span>
                </div>
                <span class="legend-count"><count-to :start-val="0" :end-val="statsData.activatedCard" :duration="100" />张</span>
              </div>
              <div class="legend-item">
                <div class="legend-label-group">
                  <span class="legend-dot color-stopped"></span>
                  <span class="legend-text">停用状态</span>
                </div>
                <span class="legend-count"><count-to :start-val="0" :end-val="statsData.stoppedCard" :duration="100" />张</span>
              </div>
              <div class="legend-item">
                <div class="legend-label-group">
                  <span class="legend-dot color-invalid"></span>
                  <span class="legend-text">作废状态</span>
                </div>
                <span class="legend-count"><count-to :start-val="0" :end-val="statsData.invalidCard" :duration="100" />张</span>
              </div>
            </div>
            <div class="total-card-box">
              <div class="total-label">卡片总数(张)</div>
              <count-to :start-val="0" :end-val="statsData.totalCard" :duration="100" class="total-num" />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 搜索筛选区域  -->
    <div class="content query-block">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="0">
        <!-- 号段(复合) -->
        <el-form-item prop="iccidRange">
          <div class="range-input-inline">
            <el-input v-model="queryParams.startIccid" placeholder="卡号起始" clearable class="wd-220"></el-input>
            <span class="range-sep">-</span>
            <el-input v-model="queryParams.endIccid" placeholder="卡号结束" clearable class="wd-220"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="iccid">
          <el-input v-model="queryParams.iccid" placeholder="卡号/批量卡号" clearable class="wd-220"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="subIccid">
          <el-input v-model="queryParams.subIccid" placeholder="子卡iccid" clearable class="wd-220"></el-input>
        </el-form-item> -->
        <el-form-item prop="imei">
          <el-input v-model="queryParams.imei" placeholder="IMEI" clearable class="wd-220"></el-input>
        </el-form-item>
        <el-form-item prop="productName">
          <el-input v-model="queryParams.productName" placeholder="套餐名称" clearable class="wd-220"></el-input>
        </el-form-item>
        <el-form-item prop="status">
          <el-select v-model="queryParams.status" placeholder="组网状态" @change="handleQuery" clearable class="wd-220">
            <el-option value="4" label="可用"></el-option>
            <el-option value="5" label="停用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="userId">
          <el-cascader
            placeholder="归属账号"
            ref="myCascader"
            :options="agentTree"
            :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false,multiple: true }"
            :show-all-levels="false"
            clearable
            v-model="queryParams.userIds"
            filterable
            @change="handleQuery"
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="msisdn">
          <el-input v-model="queryParams.msisdn" placeholder="业务号码/批量业务号码" clearable class="wd-220"></el-input>
        </el-form-item>
        <el-form-item prop="orderNum">
          <el-input v-model="queryParams.orderNum" placeholder="订单号" clearable class="wd-220"></el-input>
        </el-form-item>
        <el-form-item prop="remark">
          <el-input v-model="queryParams.remark" placeholder="备注" clearable class="wd-220"></el-input>
        </el-form-item>
        <el-form-item prop="activeTimeRange">
          <el-date-picker
            v-model="queryParams.activeTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="卡激活时间起"
            end-placeholder="卡激活时间止"
            value-format="yyyy-MM-dd"
            @change="handleQuery"
            class="wd-320">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="packageActiveTimeRange">
          <el-date-picker
            v-model="queryParams.packageActiveTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="套餐激活时间起"
            end-placeholder="套餐激活时间止"
            value-format="yyyy-MM-dd"
            @change="handleQuery"
            class="wd-320">
          </el-date-picker>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          <el-button type="primary" icon="el-icon-download" v-if="checkPermi(['card:multiNet:export'])" @click="handleExport">导出</el-button>
          <el-button type="primary" icon="el-icon-upload2" v-if="checkPermi(['card:multiNet:import'])" @click="handleImport">导入</el-button>
        </el-form-item>
        <el-form-item>
          <el-dropdown @command="handleBatchCommand">
            <el-button type="primary" plain>SIM配置<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="handlePackageOrder" v-if="checkPermi(['order:multiNet:order'])" icon="el-icon-goods">套餐订购</el-dropdown-item>
              <el-dropdown-item command="handleCardCallback" v-if="checkPermi(['card:multiNet:recycle'])" icon="el-icon-delete">卡片回收</el-dropdown-item>
              <el-dropdown-item command="handleCardTransfer" v-if="checkPermi(['card:multiNet:allocation'])" icon="el-icon-sort">卡片划拨</el-dropdown-item>
              <el-dropdown-item command="handleEditRemark" v-if="checkPermi(['card:multiNet:batchRemark'])" icon="el-icon-edit-outline">修改备注</el-dropdown-item>
              <el-dropdown-item command="handlePackageReset" v-if="checkPermi(['card:multiNet:clear'])" icon="el-icon-brush">卡清除</el-dropdown-item>
              <el-dropdown-item command="handlePackageMigrate" v-if="checkPermi(['card:multiNet:migrate'])" icon="el-icon-connection">套餐转移</el-dropdown-item>
              <el-dropdown-item command="handleSwitchCard" v-if="checkPermi(['card:multiNet:batchSwitch'])" icon="el-icon-position">批量换卡</el-dropdown-item>
              <el-dropdown-item command="handleBatchUnpack" v-if="checkPermi(['card:multiNet:batchUnpack'])"  icon="el-icon-unlock">批量拆网</el-dropdown-item>
              <el-dropdown-item command="handleUpdateStatus" v-if="checkPermi(['card:multiNet:batchStatus'])" icon="el-icon-edit">批量修改状态</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      v-loading="loading"
      ref="tableData"
      @sort-change="tableSortChange"
      @selection-change="handleSelectionChange"
      class="data-table"
      stripe
    >
      <el-table-column type="selection" align="center" width="50"></el-table-column>
      <el-table-column prop="groupNo" label="cid" align="center" width="120" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" @click="goMultiNetDetail(scope.row.groupNo)">{{ scope.row.groupNo }}</el-link>
          <el-tooltip class="item" effect="dark" :content="$t('app.common.copy')" placement="top-start">
              <i style="font-size:16px;margin-left:2px" class="el-icon-document-copy" @click="copy(scope.row.groupNo)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="diagnostic" label="智能诊断" align="center" width="90" fixed="left">
        <template slot-scope="scope">
          <el-tooltip content="智能诊断" placement="top">
            <svg-icon style="font-size: 20px;" icon-class="diagnosis" @click="handleDiagnostic(scope.row)"/>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="imei" label="IMEI" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="msisdn" label="业务号码" align="center" width="170">
        <template slot-scope="scope">
          <div class="multi-iccid">
            <div v-if="scope.row.ydMsisdn">移动：{{ scope.row.ydMsisdn }}</div>
            <div v-if="scope.row.dxMsisdn">电信：{{ scope.row.dxMsisdn }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="多网卡号" align="center" width="250">
        <template slot-scope="scope">
          <div class="multi-iccid-row">
            <div class="multi-iccid-list">
              <div v-if="scope.row.ydIccid">移动：<el-link type="primary" :underline="false" @click="goCardDetail(scope.row.ydIccid)">{{ scope.row.ydIccid }}</el-link></div>
              <div v-if="scope.row.dxIccid">电信：<el-link type="primary" :underline="false" @click="goCardDetail(scope.row.dxIccid)">{{ scope.row.dxIccid }}</el-link></div>
            </div>
            <el-tooltip v-if="scope.row.ydIccid || scope.row.dxIccid" class="item" effect="dark" :content="$t('app.common.copy')" placement="top-start">
              <i class="copy-icon el-icon-document-copy" @click="copyMultiIccid(scope.row)"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="operationName" label="运营商" align="center" width="80"></el-table-column>
      <el-table-column prop="agentName" label="归属账号" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="productName" label="套餐" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="hasDisablePackage" label="有无待用套餐" align="center" width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.stopProduct === '1' ? '有' : '无' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cardActiveTime" align="center" width="140" :show-overflow-tooltip="true">
        <template slot="header">
          卡激活时间
          <el-tooltip effect="dark" trigger="click" placement="top" content="sim卡测试套餐生效时间">
            <i class="el-icon-question header-tip"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          {{ parseTime(scope.row.cardActiveTime,'{y}-{m}-{d}') }}
        </template>
      </el-table-column>
      <el-table-column prop="productActiveTime" align="center" width="140">
        <template slot="header">
          套餐激活时间
          <el-tooltip effect="dark" trigger="click" placement="top" content="sim卡正式套餐生效时间">
            <i class="el-icon-question header-tip"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          {{ parseTime(scope.row.productActiveTime,'{y}-{m}-{d}') }}
        </template>
      </el-table-column>
      <el-table-column prop="productExpireTime" label="套餐到期时间" align="center" width="140">
        <template slot="header">
          套餐到期时间
          <el-tooltip effect="dark" trigger="click" placement="top" content="sim卡正式套餐到期时间">
            <i class="el-icon-question header-tip"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          {{ parseTime(scope.row.productExpireTime,'{y}-{m}-{d}') }}
        </template>
      </el-table-column>
      <el-table-column prop="monthFlow" label="当月用量(MB)" align="center" width="130" sortable="custom"></el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === '4'" type="success">可用</el-tag>
          <el-tag v-else-if="scope.row.status === '5'" type="danger">停用</el-tag>
          <el-tag v-else type="info">作废</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" :show-overflow-tooltip="true" min-width="150">
        <template slot-scope="scope">
          <div class="remark-cell">
            <span class="remark-cell-text">{{ scope.row.remark || '' }}</span>
            <el-tooltip effect="dark" content="修改备注" placement="top">
              <i class="remark-cell-edit el-icon-edit-outline" @click.stop="handleRowEditRemark(scope.row)"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="country" label="国家" align="center" width="80"></el-table-column>
      <el-table-column label="更多" align="center" width="90" fixed="right">
        <template slot-scope="scope">
          <div class="more-actions">
            <el-button type="text" @click="handleRefreshCard(scope.row)">刷新</el-button>
            <el-button v-hasPermi="['card:multiNet:stop']"  v-if="scope.row.status === '4'" type="text" @click="handleStopCard(scope.row)" class="danger-text-btn" style="margin-left: 0px;">停用</el-button>
            <el-button v-hasPermi="['card:multiNet:open']" v-if="scope.row.status === '5'" type="text" @click="handleStartCard(scope.row)" class="success-text-btn" style="margin-left: 0px;">启用</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 卡备注 -->
    <el-dialog title="备注" :visible.sync="openRemark" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="remarkForm" :model="remarkForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="组网列表" prop="iccids">
              <el-input v-model="remarkForm.iccids" type="textarea" clearable placeholder="请输入组网列表"  rows="8" @input="changeRemarkIccids"></el-input>
              <div class="card-num" v-if="remarkIccidsCount>0"><span>总数：</span><span>{{remarkIccidsCount}}</span></div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="组网范围" >
          <el-col :span="11">
            <el-form-item prop="startIccid">
              <el-input
                v-model="remarkForm.startIccid"
                clearable
                placeholder="请输入开始值"
                @input = "changeRemarkIccidRange"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="endIccid">
              <el-input
                v-model="remarkForm.endIccid"
                clearable
                placeholder="请输入结束值"
                @input = "changeRemarkIccidRange"
              ></el-input>
            </el-form-item>
          </el-col>
          <div class="card-num" v-if="remarkIccidRangeCount>0"><span>总数：</span><span>{{remarkIccidRangeCount}}</span></div>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="remarkForm.remark" placeholder="请输入备注" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemarkForm" >{{ $t('app.common.confirm') }}</el-button>
        <el-button @click="cancelRemark">{{ $t('app.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 单行修改备注 -->
    <el-dialog title="修改备注" :visible.sync="openRowRemark" width="480px" append-to-body :close-on-click-modal="false">
      <el-form ref="rowRemarkForm" :model="rowRemarkForm" label-width="90px">
        <el-form-item label="组网号">
          <span class="row-remark-groupno">{{ rowRemarkForm.groupNo }}</span>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="rowRemarkForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="rowRemarkSaving" @click="submitRowRemarkForm">确 定</el-button>
        <el-button @click="cancelRowRemark">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 卡清除 -->
    <el-dialog title="清除" :visible.sync="openRemoval" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="removalForm" :model="removalForm" label-width="120px">
        <el-form-item label="组网号列表" prop="iccids">
          <el-input v-model="removalForm.iccids" type="textarea" clearable placeholder="请输入内容" rows="8" @input="changeRemovalIccids"></el-input>
          <div class="card-num" v-if="removalIccidsCount>0"><span>总数：</span><span>{{removalIccidsCount}}</span></div>
        </el-form-item>
        <el-form-item label="组网号范围" >
          <el-row>
            <el-col :span="11">
              <el-form-item prop="iccidStart">
                <el-input
                  v-model="removalForm.iccidStart"
                  clearable
                  placeholder="包含开始值"
                  @input = "changeRemovalIccidRange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col style="text-align: center;" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="iccidEnd">
                <el-input
                  v-model="removalForm.iccidEnd"
                  clearable
                  placeholder="包含终止值"
                  @input = "changeRemovalIccidRange"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="card-num" v-if="removalIccidRangeCount>0"><span>总数：</span><span>{{removalIccidRangeCount}}</span></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemovalForm" >确 定</el-button>
        <el-button @click="cancelRemoval">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 批量拆网 -->
    <el-dialog title="批量拆网" :visible.sync="openUnbindGroup" width="700px" append-to-body :close-on-click-modal="false">
      <el-form ref="unbindGroupForm" :model="unbindGroupForm" label-width="160px">
        <el-form-item label="ICCID/组网号列表" prop="iccids">
          <el-input v-model="unbindGroupForm.iccids" type="textarea" clearable placeholder="请输入内容" rows="8" @input="changeUnbindGroupIccids"></el-input>
          <div class="card-num" v-if="unbindGroupIccidsCount>0"><span>总数：</span><span>{{unbindGroupIccidsCount}}</span></div>
        </el-form-item>
        <el-form-item label="ICCID/组网号范围" >
          <el-row>
            <el-col :span="11">
              <el-form-item prop="iccidStart">
                <el-input
                  v-model="unbindGroupForm.iccidStart"
                  clearable
                  placeholder="包含开始值"
                  @input = "changeUnbindGroupIccidRange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col style="text-align: center;" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="iccidEnd">
                <el-input
                  v-model="unbindGroupForm.iccidEnd"
                  clearable
                  placeholder="包含终止值"
                  @input = "changeUnbindGroupIccidRange"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="card-num" v-if="unbindGroupIccidRangeCount>0"><span>总数：</span><span>{{unbindGroupIccidRangeCount}}</span></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUnbindGroupForm" >确 定</el-button>
        <el-button @click="cancelUnbindGroup">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 批量添加弹出框 -->
    <el-dialog title="组网卡导入" :visible.sync="importOpen" width="680px" append-to-body :close-on-click-modal="false">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="卡号列表" prop="iccids">
              <el-upload
                ref="upload"
                :limit="1"
                accept=".xlsx, .xls"
                :headers="upload.headers"
                :action="upload.url"
                :disabled="upload.isUploading"
                :on-progress="handleFileUploadProgress"
                :on-success="handleFileSuccess"
                :auto-upload="false"
                drag
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                  <span>仅允许导入xls、xlsx格式文件。</span>
                  <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="importTemplate">下载模板</el-link>
                </div>
              </el-upload>
              <div style="padding-top:10px">
                <p style="font-size: 13px;line-height: 30px;color: #909399;">1、批量上传ICCID1和ICCID2</p>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="cancelImport">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 批量更新状态 -->
    <el-dialog title="批量更新状态" :visible.sync="openUpdateStatus" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="updateStatusForm" :model="updateStatusForm" label-width="160px">
        <el-form-item label="更新状态" prop="status">
          <el-radio-group v-model="updateStatusForm.status">
            <el-radio label="4">开启</el-radio>
            <el-radio label="5">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="组网号/ICCID列表" prop="iccids">
          <el-input v-model="updateStatusForm.iccids" type="textarea" clearable placeholder="请输入内容" rows="8" @input="changeUpdateStatusIccids"></el-input>
          <div class="card-num" v-if="updateStatusIccidsCount>0"><span>总数：</span><span>{{updateStatusIccidsCount}}</span></div>
        </el-form-item>
        <el-form-item label="组网号/ICCID范围" >
          <el-row>
            <el-col :span="11">
              <el-form-item prop="iccidStart">
                <el-input
                  v-model="updateStatusForm.iccidStart"
                  clearable
                  placeholder="包含开始值"
                  @input = "changeRemovalIccidRange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col style="text-align: center;" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="iccidEnd">
                <el-input
                  v-model="updateStatusForm.iccidEnd"
                  clearable
                  placeholder="包含终止值"
                  @input = "changeRemovalIccidRange"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="card-num" v-if="updateStatusIccidRangeCount>0"><span>总数：</span><span>{{updateStatusIccidRangeCount}}</span></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpdateStatusForm" >确 定</el-button>
        <el-button @click="cancelUpdateStatus">取 消</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
import { cardMultiNetList, cardMultiNetCount , batchUnpackCardMultiCard ,refreshMultiNetCard ,exportMultiNet , batchUpdateMultiCardStatus ,stopMultiNetCard, openMultiNetCard , saveRemark} from '@/api/multiNet'
import { selectCount,agentTreeList ,batchCardRemark , removalCard} from "@/api/api.js";
import { getToken } from '@/utils/auth'
import CountTo from 'vue-count-to'
export default {
  name: 'card/multiNet',
  components: {
    CountTo
  },
  data() {
    return {
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      selectedIccids: [],
      selectedOperator: '',
      // 代理商
      agentTree: [],
      // 统计数据
      statsData: {
        ydCount: 0,
        dxCount: 0,
        multiCount: 0,

        totalCard: 0,
        //百分比
        mobilePercent: 75,
        telecomPercent: 55,
        multiPercent: 60,
        //状态
        usableCard: 0,
        activatedCard: 0,
        stoppedCard: 0,
        invalidCard: 0
      },
      mobileColor: '#67c23a',
      telecomColor: '#909399',
      multiColor: '#67c23a',
      // 查询参数
      queryParams: {
        startIccid: '',
        endIccid: '',
        productName: '',
        cardStatus: '',
        userId: '',
        msisdn: '',
        iccid: '',
        activeTimeRange: [],
        packageActiveTimeRange: [],
        orderNum: '',
        subIccid: '',
        imei: '',
        remark: '',
        status: ''
      },
      packageList: [
        { id: '1', name: '终身套餐' },
        { id: '2', name: '月度套餐' },
        { id: '3', name: '季度套餐' },
        { id: '4', name: '年度套餐' }
      ],
      userList: [],
      tableData: [],
      openRemark: false,
      remarkForm: {
        fieldType: '1',
        iccids: '',
        startIccid: '',
        endIccid: '',
        remark: ''
      },
      remarkIccidsCount:0,
      remarkIccidRangeCount:0,
      openRowRemark: false,
      rowRemarkForm: {
        groupNo: '',
        remark: ''
      },
      rowRemarkSaving: false,
      openRemoval: false,
      removalForm: {
        fieldType: '1',
        iccids: '',
        iccidStart: '',
        iccidEnd: ''
      },
      removalIccidsCount:0,
      removalIccidRangeCount:0,
      importOpen: false,
      upload: {
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: getToken()},
        // 上传的地址
        url: "/cms/card/multiNet/import",
      },
      openUnbindGroup: false,
      unbindGroupForm: {
        fieldType: '1',
        iccids: '',
        iccidStart: '',
        iccidEnd: ''
      },
      unbindGroupIccidsCount:0,
      unbindGroupIccidRangeCount:0,
      openUpdateStatus: false,
      updateStatusForm: {
        status: '4',
        iccids: '',
        iccidStart: '',
        iccidEnd: '',
        cardStatus: ''
      },
      updateStatusIccidsCount:0,
      updateStatusIccidRangeCount:0,
    }
  },
  computed: {
    circumference() {
      return 2 * Math.PI * 50
    },
    mobileDashArray() {
      const percent = this.statsData.mobilePercent || 0
      const dash = (percent / 100) * this.circumference
      return `${dash} ${this.circumference}`
    },
    telecomDashArray() {
      const percent = this.statsData.telecomPercent || 0
      const dash = (percent / 100) * this.circumference
      return `${dash} ${this.circumference}`
    },
    multiDashArray() {
      const percent = this.statsData.multiPercent || 0
      const dash = (percent / 100) * this.circumference
      return `${dash} ${this.circumference}`
    }
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'card/multiNet'){
          this.getList()
          this.selectYdCount()
          this.selectDxCount()
          this.selectMultiCount()
          this.selectStatusCount()
        }
      },
      deep: true
    }
  },
  created() {
    this.getList()
    this.selectYdCount()
    this.selectDxCount()
    this.selectMultiCount()
    this.selectStatusCount()
    this.handleAgentTreeList()
  },
  
  methods: {
    tableSortChange(val){
      this.queryParams.order = val.order == "descending" ? "desc" : "asc";
      if(val.prop == 'monthFlow'){
        this.queryParams.sort = 'monthFlow'
      }
      if(!val.order){
        this.queryParams.order = undefined
        this.queryParams.sort = undefined
      }
      this.getList()
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList({self:'1'}).then(res => {
        this.agentTree = res.data.data;
      });
    },
    selectYdCount(){
      cardMultiNetCount({
        type: "1",
        value: '中国移动'
      }).then(res => {
        this.statsData.ydCount = res.data.data.total || 0
      })
    },
    selectDxCount(){
      cardMultiNetCount({
        type: "1",
        value: '中国电信'
      }).then(res => {
        this.statsData.dxCount = res.data.data.total || 0
      })
    },
    selectMultiCount(){
      cardMultiNetCount({
        type: "1",
        value: '多网'
      }).then(res => {
        this.statsData.multiCount = res.data.data.total || 0
      })
    },
    selectStatusCount(){
      cardMultiNetCount({
        type: "2"
      }).then(res => {
        this.statsData.totalCard = res.data.data.total || 0
        this.statsData.stoppedCard = res.data.data.shutDown || 0
        this.statsData.activatedCard = res.data.data.activated || 0
        //待激活
        this.statsData.usableCard = res.data.data.wait || 0
        this.statsData.invalidCard = res.data.data.del || 0
      })
    },
    // 运营商点击筛选
    handleOperatorClick(type) {
      const operatorMap = {
        mobile: '中国移动',
        telecom: '中国电信',
      }
      // 点击圆形区域直接跳转到sim卡列表，并按运营商筛选
      this.$router.push({
        path: '/device/cards',
        query: { operatorName: operatorMap[type] }
      })
    },
    // 查询
    handleQuery() {
      this.page = 1
      this.getList()
    },
    // 重置
    resetQuery() {
      this.$refs.queryForm.resetFields()
      this.queryParams.startIccid = ''
      this.queryParams.endIccid = ''
      this.queryParams.activeTimeRange = []
      this.queryParams.packageActiveTimeRange = []
      this.selectedOperator = ''
      this.queryParams.userIds = []
      this.$refs.tableData.clearSort()
      this.queryParams.order = undefined
      this.queryParams.sort = undefined
      this.$refs.myCascader.$refs.panel.clearCheckedNodes();
      this.$refs.myCascader.$refs.panel.activePath = [];
      this.page = 1
      this.getList()
    },
    // 获取列表数据
    getList() {
      this.loading = true
      cardMultiNetList({
        model:{
          ...this.queryParams,
          ...this.addDateRange({}, this.queryParams.activeTimeRange,'CardActiveTime'),
          ...this.addDateRange({}, this.queryParams.packageActiveTimeRange,'ProductActiveTime')
        },
        page: this.page,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.records || []
          this.total = res.data.data.total || 0
          this.loading = false
        } else {
          this.$message.error(res.msg || '获取多网卡列表失败')
          this.loading = false
        }
      })
    },
    // 表格选择
    handleSelectionChange(val) {
      let groupNosList = val.map(item=>item.groupNo)
      this.selectedIccids = groupNosList
    },
    // 刷新表格
    refreshTable() {
      this.getList()
    },
    // 套餐订购
    handlePackageOrder() {
      this.$router.push({ name: 'multiNetOrder' ,params:{iccids:this.selectedIccids.toString().replaceAll(",","\n")}})
    },
    // 卡片回拨,回收
    handleCardCallback() {
      this.$router.push({name:"multiNetRecycle",params:{iccids:this.selectedIccids.toString().replaceAll(",","\n")}});
    },
    // 卡片划拨
    handleCardTransfer() {
      this.$router.push({name:"multiNetAllocation",params:{iccids:this.selectedIccids.toString().replaceAll(",","\n")}});
    },
    // 修改备注
    handleEditRemark() {
      this.openRemark =true;
      this.remarkIccidsCount = 0
      this.remarkForm.iccids = this.selectedIccids.toString().replaceAll(",","\n")
      let arrIccids = this.remarkForm.iccids ? this.remarkForm.iccids.split("\n") : []
      this.remarkIccidsCount = arrIccids.filter(item=>!!item).length
      this.changeRemarkIccidRange()
    },
    // 单行修改备注
    handleRowEditRemark(row) {
      this.openRowRemark = true
      this.rowRemarkForm.groupNo = row.groupNo
      this.rowRemarkForm.remark = row.remark || ''
    },
    cancelRowRemark() {
      this.openRowRemark = false
      this.rowRemarkSaving = false
      this.$refs['rowRemarkForm'].resetFields()
    },
    submitRowRemarkForm() {
      if (!this.rowRemarkForm.groupNo) {
        this.$message.warning('组网号不存在')
        return
      }
      this.rowRemarkSaving = true
      let data = {
        groupNo: this.rowRemarkForm.groupNo,
        remark: this.rowRemarkForm.remark
      }
      saveRemark(data).then(res => {
        this.rowRemarkSaving = false
        if (res.data.code === 200) {
          this.$message.success('备注修改成功')
          this.openRowRemark = false
          this.$refs['rowRemarkForm'].resetFields()
          this.getList()
        } else {
          this.$message.error(res.data.message || res.msg || '备注修改失败')
        }
      }).catch(() => {
        this.rowRemarkSaving = false
        this.$message.error('备注修改失败')
      })
    },
    // 机卡解绑
    handleUnbindImei() {
      this.$confirm('确认对选中的卡片进行机卡解绑操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('机卡解绑操作成功')
      }).catch(() => {})
    },
    // 主动激活
    handleActiveCard() {
      this.$confirm('确认对选中的卡片进行主动激活操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('主动激活操作成功')
      }).catch(() => {})
    },
    // 套餐重置
    handlePackageReset() {
      this.openRemoval =true;
      this.removalIccidRangeCount = 0
      this.removalForm.iccids = this.selectedIccids.toString().replaceAll(",","\n")
      let arrIccids = this.removalForm.iccids ? this.removalForm.iccids.split("\n") : []
      this.removalIccidsCount = arrIccids.filter(item=>!!item).length
    },
    // 套餐迁移：携带选中的组网号跳转批量转套餐页
    handlePackageMigrate() {
      this.$router.push({
        name: 'multiNetTurnProduct',
        params:{iccids:this.selectedIccids.toString()}
      })
    },
    // 批量换卡：将选中组网号带入换卡页面;未选中则让用户手动添加
    handleSwitchCard() {
      this.$router.push({
        name: 'multiNetSwitch',
        params:{iccids:this.selectedIccids.toString()}
      })
    },
    // 批量拆网
    handleUnbindGroup() {
      this.openUnbindGroup =true;
      this.unbindGroupIccidRangeCount = 0
      this.unbindGroupForm.iccids = this.selectedIccids.toString().replaceAll(",","\n")
      let arrIccids = this.unbindGroupForm.iccids ? this.unbindGroupForm.iccids.split("\n") : []
      this.unbindGroupIccidsCount = arrIccids.filter(item=>!!item).length
      this.changeUnbindGroupIccidRange()
    },
    // 批量拆网：将选中组网号带入拆网页面;未选中则让用户手动添加
    handleBatchUnpack() {
      this.$router.push({
        name: 'multiNetUnpack',
        params:{iccids:this.selectedIccids.toString()}
      })
    },
    // 下拉批量操作分发
    handleBatchCommand(command) {
      if (typeof this[command] === 'function') {
        this[command]()
      }
    },
    // 导出
    handleExport() {
      let params = {
          ...this.queryParams,
          ...this.addDateRange({}, this.queryParams.activeTimeRange,'CardActiveTime'),
          ...this.addDateRange({}, this.queryParams.packageActiveTimeRange,'ProductActiveTime')
      }
      exportMultiNet(params).then(res=>{
        if(res.data.code === 200){
          this.$message.success('导出成功,前往任务中心下载')
          setTimeout(()=>{
            this.$router.push({ path: '/taskCenter/missionList' })
          },1000)
        }else{
          this.$message.error(res.msg || '导出失败')
        }
      })
    },
    // 智能诊断
    handleDiagnostic(row) {
      this.$router.push({ path: '/card/multiNet/info', query: { groupNo: row.groupNo ,tab:'diagnosis'} })
    },
    // 刷新卡片
    handleRefreshCard(row) {
      refreshMultiNetCard({groupNo:row.groupNo}).then(res=>{
        if(res.data.code === 200){
          this.$message.success('刷新成功')
          this.refreshTable()
        }else{
          this.$message.error(res.msg || '刷新失败')
        }
      })
    },
    // 停用卡片
    handleStopCard(row) {
      this.$confirm(`确认停用卡片 ${row.groupNo}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        stopMultiNetCard({groupNo:row.groupNo}).then(res=>{
          if(res.data.code === 200){
            this.$message.success('组网卡停用处理中')
            this.refreshTable()
          }else{
            this.$message.error(res.msg || '停用失败')
          }
        })
      }).catch(() => {})
    },
    handleStartCard(row){
      this.$confirm(`确认启用卡片 ${row.groupNo}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        openMultiNetCard({groupNo:row.groupNo}).then(res=>{
          if(res.data.code === 200){
            this.$message.success('组网卡启用处理中')
            this.refreshTable()
          }else{
            this.$message.error(res.msg || '启用失败')
          }
        })
      }).catch(() => {})
    },
    // 跳转组网详情
    goMultiNetDetail(groupNo) {
      if (!groupNo) {
        this.$message.warning('组网ID不存在')
        return
      }
      this.$router.push({ path: `/card/multiNet/info`, query: { groupNo } })
    },
    // 跳转卡详情
    goCardDetail(iccid) {
      if (!iccid) {
        this.$message.warning('卡号不存在')
        return
      }
      this.$router.push({ path: '/card/detail', query: { iccid } })
    },
    changeRemarkIccids(){
      let arrIccids = this.remarkForm.iccids ? this.remarkForm.iccids.split("\n") : []
      this.remarkIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeRemarkIccidRange(){
      this.remarkIccidRangeCount = 0
      let fieldType = this.remarkForm.fieldType
      if(!!this.remarkForm.startIccid && !!this.remarkForm.endIccid){
            if(this.remarkForm.startIccid.length>8 && this.remarkForm.endIccid.length>8){
              let startIccid = this.remarkForm.startIccid
              let endIccid =  this.remarkForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.remarkIccidRangeCount = res.data.data
              })
            }
      }
    },
    cancelRemark(){
      this.openRemark =false;
      this.$refs['remarkForm'].resetFields();
    },
    submitRemarkForm(){
      let { iccids } = this.remarkForm;
      let data = {
        ...this.remarkForm,
        operatorType:'1',
        iccids:iccids ? iccids.split("\n") : []
      };
      batchCardRemark(data).then(res => {
        this.$notify({
          title: "成功",
          message: "批量备注成功，请在任务中心查看进度",
          type: "success",
          offset:30
        });
        this.$refs['remarkForm'].resetFields();
        this.openRemark = false;
        this.remarkIccidsCount = 0
        this.remarkIccidRangeCount = 0
        this.getList()
      });
    },
    changeRemovalIccids(){
      let arrIccids = this.removalForm.iccids ? this.removalForm.iccids.split("\n") : []
      this.removalIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeRemovalIccidRange(){
      this.removalIccidRangeCount = 0
      let fieldType = this.removalForm.fieldType
      if(!!this.removalForm.iccidStart && !!this.removalForm.iccidEnd){
        if(this.removalForm.iccidStart.length>8 && this.removalForm.iccidEnd.length>8){
          let startIccid = this.removalForm.iccidStart
          let endIccid =  this.removalForm.iccidEnd
          selectCount({fieldType,startIccid,endIccid}).then(res=>{
            this.removalIccidRangeCount = res.data.data
          })
        }
      }
    },
    cancelRemoval(){
      this.openRemoval =false;
      this.$refs['removalForm'].resetFields();
    },
    submitRemovalForm(){
      removalCard(this.removalForm).then(res => {
            if(res.data.code ==200){
              this.$message.success("清除成功，任务中心查看进度");
              this.openRemoval = false;
              this.$refs['removalForm'].resetFields();
            }else{
              this.$message.error(res.data.message);
            }
        });
    },
    handleUpdateStatus(){
      this.openUpdateStatus = true;
      this.updateStatusIccidsCount = 0
      this.updateStatusForm.iccids = this.selectedIccids.toString().replaceAll(",","\n")
      let arrIccids = this.updateStatusForm.iccids ? this.updateStatusForm.iccids.split("\n") : []
      this.updateStatusIccidsCount = arrIccids.filter(item=>!!item).length
      this.changeUpdateStatusIccidRange()
      
    },
    changeUpdateStatusIccids(){
      let arrIccids = this.updateStatusForm.iccids ? this.updateStatusForm.iccids.split("\n") : []
      this.updateStatusIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeUpdateStatusIccidRange(){
      this.updateStatusIccidRangeCount = 0
      let fieldType = '1'
      if(!!this.updateStatusForm.iccidStart && !!this.updateStatusForm.iccidEnd){
        if(this.updateStatusForm.iccidStart.length>8 && this.updateStatusForm.iccidEnd.length>8){
          let startIccid = this.updateStatusForm.iccidStart
          let endIccid =  this.updateStatusForm.iccidEnd
          selectCount({fieldType,startIccid,endIccid}).then(res=>{
            this.updateStatusIccidRangeCount = res.data.data
          })
        }
      }
    },
    cancelUpdateStatus(){
      this.openUpdateStatus =false;
      this.$refs['updateStatusForm'].resetFields();
      this.updateStatusIccidsCount = 0
      this.updateStatusIccidRangeCount = 0
    },
    submitUpdateStatusForm(){
      batchUpdateMultiCardStatus(this.updateStatusForm).then(res => {
            if(res.data.code ==200){
              this.$message.success("更新成功，任务中心查看进度");
              this.openUpdateStatus = false;
              this.$refs['updateStatusForm'].resetFields();
              this.updateStatusIccidsCount = 0
              this.updateStatusIccidRangeCount = 0
              this.getList()
            }else{
              this.$message.error(res.data.message);
            }
        });
    },

    handleImport(){
      this.importOpen = true;
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
    // 取消导入
    cancelImport(){
      this.importOpen = false;
      this.$refs.upload.clearFiles();
    },
    importTemplate() {
      this.download('/card/multiNet/importTemplate', {
      }, `组网卡导入模板_${new Date().getTime()}.xlsx`)
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.importOpen = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.getList();
    },
    changeUnbindGroupIccids(){
      let arrIccids = this.unbindGroupForm.iccids ? this.unbindGroupForm.iccids.split("\n") : []
      this.unbindGroupIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeUnbindGroupIccidRange(){
      this.unbindGroupIccidRangeCount = 0
      let fieldType = this.unbindGroupForm.fieldType
      if(!!this.unbindGroupForm.iccidStart && !!this.unbindGroupForm.iccidEnd){
        if(this.unbindGroupForm.iccidStart.length>8 && this.unbindGroupForm.iccidEnd.length>8){
          let startIccid = this.unbindGroupForm.iccidStart
          let endIccid =  this.unbindGroupForm.iccidEnd
          selectCount({fieldType,startIccid,endIccid}).then(res=>{
            this.unbindGroupIccidRangeCount = res.data.data
          })
        }
      }
    },
    cancelUnbindGroup(){
      this.openUnbindGroup =false;
      this.$refs['unbindGroupForm'].resetFields();
      this.unbindGroupIccidsCount = 0
      this.unbindGroupIccidRangeCount = 0
    },
    submitUnbindGroupForm(){
      batchUnpackCardMultiCard(this.unbindGroupForm).then(res => {
          if(res.data.code ==200){
            this.$message.success("清除成功，任务中心查看进度");
            this.openUnbindGroup = false;
            this.$refs['unbindGroupForm'].resetFields();
            this.getList()
          }else{
            this.$message.error(res.data.message);
          }
      });
    },
    //复制数据
    copy(data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
            message: '复制成功',
            type: 'success',
            duration:1000
        });
        oInput.remove()
    },
    // 一次性复制移动+电信卡号
    copyMultiIccid(row) {
      let arr = []
      if (row.ydIccid) arr.push(row.ydIccid)
      if (row.dxIccid) arr.push(row.dxIccid)
      this.copy(arr.join('  '))
    },

  }
}
</script>

<style lang="scss" scoped>
.card-group-container {
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 16px;
    padding: 12px 20px;
    background: #fff;
    border-radius: 4px;
  }

  .stats-row {
    margin-bottom: 16px;

    /* 左右两列等高 (flex row 自动按最高列对齐) */
    display: flex;
    align-items: stretch;

    .el-col {
      display: flex;
    }

    .stats-card {
      background: #fff;
      border-radius: 4px;
      padding: 20px;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: stretch;
      border: 1px solid #ebeef5;
    }

    /* 左列(stats-left): 环形卡 + 底部提示文字 -> 上下排布  */
    .stats-left .legend-total-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    /* 右列(stats-right): 图例左、总数右 -> 左右排布  */
    .stats-right .legend-total-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .ring-cards {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 10px 0 20px;

      .ring-card-item {
        cursor: pointer;
        text-align: center;
        transition: transform 0.3s ease;

        &:hover {
          transform: translateY(-4px);
        }

        .ring-progress {
          position: relative;
          width: 110px;
          height: 110px;

          .ring-svg {
            width: 100%;
            height: 100%;
          }

          .ring-center-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 70px;
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            border-radius: 50%;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

            .center-count {
              font-size: 24px;
              font-weight: 700;
              line-height: 1;
            }
            .count-mobile  { color: #67c23a; }
            .count-telecom { color: #a06cd5; }
            .count-multi   { color: #67c23a; }
          }
        }

        .ring-label {
          margin-top: 8px;
          line-height: 1.4;
        }
      }
    }

    .tip-text {
      font-size: 12px;
      color: #f56c6c;
      padding-left: 8px;
    }

    /* 左右两侧文字标签字体统一 (和左卡 移动(张)/电信(张)/多网(张) 完全一致) */
    .ring-label,
    .legend-label-group,
    .legend-text {
      font-size: 14px !important;
      color: #606266 !important;
      line-height: 1.4;
    }

    .legend-list {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .legend-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        min-width: 320px;

        .legend-label-group {
          display: flex;
          align-items: center;
        }

        .legend-dot {
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 3px;
          margin-right: 8px;

          &.color-usable {
            background: #f5c518;
          }
          &.color-activated {
            background: #67c23a;
          }
          &.color-stopped {
            background: #909399;
          }
          &.color-invalid {
            background: #e6a23c;
          }
        }
        /* 字体样式统一在 .stats-row 下的 .legend-text 公共声明中, 此处不再重复 */

        .legend-count {
          font-size: 14px;
          font-weight: 600;
          color: #303133;
          white-space: nowrap;
        }
      }
    }

    .total-card-box {
      text-align: right;
      padding-right: 30px;

      .total-label {
        font-size: 14px;
        color: #606266;
        margin-bottom: 12px;
      }

      .total-num {
        font-size: 36px;
        font-weight: 600;
        color: #303133;
      }
    }
  }

  /* 查询区结构与 device/cards.vue 对齐:
     .content 使用全局 padding:20px (来自 styles/common.scss),
     el-form-item 间距完全走 Element UI 默认, 不再覆盖 */
  .query-block {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;

    .el-form-item .el-button + .el-button {
      margin-left: 12px;
    }
  }

  .header-tip {
    color: #909399;
    cursor: pointer;
    margin-left: 4px;
    font-size: 14px;

    &:hover {
      color: #409eff;
    }
  }

  .multi-iccid {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #909399;
    line-height: 1.6;

    .el-link {
      font-size: 12px;
    }
  }

  // 多网卡号专用：卡号列表 + 复制按钮，左右居中对齐
  .multi-iccid-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #909399;
    line-height: 1.6;

    .multi-iccid-list {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .copy-icon {
      font-size: 16px;
      margin-left: 6px;
      color: #909399;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }
    }

    .el-link {
      font-size: 12px;
    }
  }

  .wd-160 { width: 160px; }
  .wd-180 { width: 180px; }
  .wd-200 { width: 200px; }
  .wd-220 { width: 220px; }
  .wd-320 { width: 320px; }

  .range-input-inline {
    display: inline-flex;
    align-items: center;

    .range-sep {
      padding: 0 2px;
      color: #909399;
      line-height: 32px;
    }

    .el-input {
      width: 220px;
    }
  }

  .action-bar {
    background: #fff;
    padding: 12px 20px;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .action-left,
    .action-right {
      display: flex;
      gap: 8px;
    }
  }

  .data-table {
    background: #fff;
    border-radius: 4px;

    .diagnostic-icon {
      font-size: 18px;
      color: #409eff;
      cursor: pointer;

      &:hover {
        color: #66b1ff;
      }
    }
  }

  // 备注单元格：文本省略 + 编辑图标
  .remark-cell {
    display: flex;
    align-items: center;
    justify-content: center;

    .remark-cell-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
      max-width: calc(100% - 24px);
    }

    .remark-cell-edit {
      flex-shrink: 0;
      font-size: 15px;
      margin-left: 4px;
      color: #909399;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }
    }
  }

  .row-remark-groupno {
    color: #606266;
    word-break: break-all;
  }

  .more-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 100%;

    .el-button--text {
      padding: 2px 0;
    }

    .danger-text-btn {
      color: #f56c6c;

      &:hover {
        color: #f78989;
      }
    }
    .success-text-btn {
      color: #67c23a;

      &:hover {
        color: #52c41a;
      }
    }
  }
}

@media (max-width: 1200px) {
  .card-group-container {
    .stats-row {
      .stats-card {
        .ring-cards {
          flex-wrap: wrap;
          gap: 16px;
        }
      }
    }
  }
}
</style>
